var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "social-date-picker" }, [
    _c("fieldset", { staticClass: "date-time" }, [
      _c(
        "div",
        { staticClass: "date" },
        [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.editing,
                  expression: "!editing"
                }
              ],
              staticClass:
                "vdp-datepicker exclude-outside-click field-value text-hover-bg",
              attrs: { tabindex: "0" },
              on: {
                click: function($event) {
                  _vm.editing = true
                },
                keyup: _vm.onWrapperKeyUp
              }
            },
            [
              _vm.postDate
                ? _c("span", {
                    staticClass:
                      "exclude-outside-click vdp-datepicker__placeholder",
                    domProps: {
                      innerHTML: _vm._s(_vm.displayPostDate(_vm.postDate))
                    }
                  })
                : _c(
                    "span",
                    {
                      staticClass:
                        "not-set exclude-outside-click  vdp-datepicker__placeholder"
                    },
                    [_vm._v("No Date")]
                  )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.editing,
                  expression: "editing"
                }
              ],
              staticClass: "custom-field date-pick-field",
              on: {
                keyup: function($event) {
                  $event.stopPropagation()
                  return _vm.onKeyUp.apply(null, arguments)
                }
              }
            },
            [
              _c(
                "DatePicker",
                {
                  directives: [
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.outside,
                      expression: "outside"
                    }
                  ],
                  ref: "customDatepicker",
                  attrs: {
                    placeholder: "No Date",
                    highlighted: _vm.highlightedDates,
                    format: _vm.displayPostDate,
                    inline: true,
                    "calendar-class": "test-date-calendar",
                    tabindex: "0",
                    autofocus: true
                  },
                  on: {
                    changedMonth: _vm.calendarChangedMonth,
                    closed: _vm.dateTimeUpdated,
                    input: _vm.dateTimeUpdated,
                    selected: _vm.setDefaultTime
                  },
                  model: {
                    value: _vm.postDate,
                    callback: function($$v) {
                      _vm.postDate = $$v
                    },
                    expression: "postDate"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "calender-header",
                      attrs: { slot: "beforeCalendarHeader" },
                      slot: "beforeCalendarHeader"
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "remove-dl-btn",
                          attrs: { variant: "text" },
                          on: { click: _vm.resetDeadline }
                        },
                        [_vm._v("Remove Deadline")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "today-btn",
                          attrs: { variant: "text" },
                          on: { click: _vm.onToday }
                        },
                        [_vm._v("Today")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "calender-footer",
                      attrs: { slot: "calendarFooter" },
                      slot: "calendarFooter"
                    },
                    [
                      _c("div", { staticClass: "time-wrapper" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.postTime,
                              expression: "postTime"
                            }
                          ],
                          ref: "refTime",
                          attrs: {
                            type: "time",
                            id: _vm.timePickerId,
                            name: "appt",
                            step: "60",
                            disabled: _vm.inputsDisabled,
                            tabindex: "1"
                          },
                          domProps: { value: _vm.postTime },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "escape",
                                  undefined,
                                  $event.key,
                                  undefined
                                )
                              ) {
                                return null
                              }
                              $event.stopPropagation()
                              return _vm.onKeyUp.apply(null, arguments)
                            },
                            blur: _vm.dateTimeUpdated,
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.postTime = $event.target.value
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "today-btn",
                          attrs: { variant: "text", tabindex: "2" },
                          on: { click: _vm.onDone }
                        },
                        [_vm._v("Done")]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.isDateDuplicate
            ? _c("i", {
                staticClass: "fas fa-exclamation-circle date-duplicate-icon",
                attrs: { id: _vm.duplicateDateTooltipId }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isDateDuplicate
            ? _c(
                "b-tooltip",
                {
                  attrs: {
                    target: _vm.duplicateDateTooltipId,
                    triggers: "hover"
                  }
                },
                [
                  _vm._v(
                    "\n        This date has multiple posts scheduled\n      "
                  )
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "time" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.postTime,
              expression: "postTime"
            }
          ],
          attrs: {
            type: "time",
            id: _vm.timePickerId,
            name: "appt",
            step: "60",
            disabled: _vm.dateTimeDisabled
          },
          domProps: { value: _vm.postTime },
          on: {
            blur: _vm.dateTimeUpdated,
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.postTime = $event.target.value
            }
          }
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }